<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 13970 13970"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0"
        d="M6985 0c-3858,0 -6985,3127 -6985,6985 0,3858 3127,6985 6985,6985 3858,0 6985,-3127 6985,-6985 0,-3858 -3127,-6985 -6985,-6985zm3072 4729l0 0c0,181 -147,328 -328,328l-495 0c-181,0 -328,-147 -328,-328l0 -988c0,-181 147,-328 328,-328l495 0c181,0 328,147 328,328l0 988zm-744 1251l0 0 209 624 -1051 4 842 -628zm-900 -1251l0 0c0,181 -146,328 -327,328l-496 0c-181,0 -327,-147 -327,-328l0 -988c0,-181 146,-328 327,-328l496 0c181,0 327,147 327,328l0 988zm-1479 0l0 0c0,181 -146,328 -327,328l-497 0c-180,0 -327,-147 -327,-328l0 -988c0,-181 147,-328 327,-328l497 0c181,0 327,147 327,328l0 988zm-3123 0l0 0c0,181 -147,328 -327,328l-496 0c-181,0 -327,-147 -327,-328l0 -988c0,-181 146,-328 327,-328l496 0c180,0 327,147 327,328l0 988zm1479 0l0 0c0,181 -146,328 -327,328l-496 0c-181,0 -327,-147 -327,-328l0 -988c0,-181 146,-328 327,-328l496 0c181,0 327,147 327,328l0 988zm1695 4189l0 0c-886,0 -1605,-718 -1605,-1604 0,-886 719,-1605 1605,-1605 887,0 1605,719 1605,1605 0,886 -718,1604 -1605,1604zm3018 2630l0 0c-828,0 -1500,-671 -1500,-1500 0,-828 672,-1500 1500,-1500 475,0 897,221 1172,566l-1276 699 432 494 861 -1171c194,253 311,569 311,912 0,829 -671,1500 -1500,1500zm1533 -6819l0 0c0,181 -146,328 -327,328l-497 0c-180,0 -327,-147 -327,-328l0 -988c0,-181 147,-328 327,-328l497 0c181,0 327,147 327,328l0 988z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'WeatherMeter',
};
</script>

<style scoped>
.fil0 {
  fill: #56D6D1;
  fill-rule: nonzero
}
</style>
